import React from 'react';
import { Grid, Box, Typography, Link as MuiLink } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import PrintIcon from '@mui/icons-material/Print';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import EmbeddedMap from './EmbeddedMap';

const Contact = () => {
  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      sx={{ py: 4 }} // reduced vertical spacing
    >
      <Grid item xs={12} sm={10} md={8}>
        <Grid container spacing={2} alignItems="stretch">

          {/* Left side: Map */}
          <Grid item xs={12} sm={6}>
            <EmbeddedMap />
          </Grid>

          {/* Right side: Contact info */}
          <Grid item xs={12} sm={6}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                boxSizing: 'border-box',
                p: 2
              }}
            >
              <Typography variant="h4" gutterBottom mb={3}>
                Contact Information
              </Typography>

              <Box display="flex" alignItems="center" mb={2}>
                <PhoneIcon sx={{ mr: 1 }} />
                <MuiLink href="tel:2108669850" underline="hover" color="inherit" component="a">
                  <Typography variant="body1">210-866-9850</Typography>
                </MuiLink>
              </Box>

              <Box display="flex" alignItems="center" mb={2}>
                <PrintIcon sx={{ mr: 1 }} />
                <Typography variant="body1">210-866-7054</Typography>
              </Box>

              <Box display="flex" alignItems="center" mb={2}>
                <EmailIcon sx={{ mr: 1 }} />
                <MuiLink href="mailto:admin@aspirebhp.com" underline="hover" color="inherit" component="a">
                  <Typography variant="body1">admin@aspirebhp.com</Typography>
                </MuiLink>
              </Box>

              <Box display="flex" alignItems="center" mb={2}>
                <LocationOnIcon sx={{ mr: 1 }} />
                <MuiLink href="https://maps.app.goo.gl/9UV9FfwReJi69fRf9" target="_blank" rel="noopener noreferrer" underline="hover" color="inherit">
                  <Typography variant="body1">
                    14855 Blanco Rd, Suite 355, San Antonio, TX, 78216
                  </Typography>
                </MuiLink>
              </Box>
            </Box>
          </Grid>

        </Grid>
      </Grid>
    </Grid>
  );
};

export default Contact;
